var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "17.5",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.33 24.7c.73.5 1.56.53 2.32 0 .76-.52 1.58-.49 2.32 0 .74.5 1.56.53 2.32 0 .76-.52 1.59-.49 2.32 0 .74.5 1.56.53 2.32 0 .67-.45 1.68-.23 1.68-.23.2.04.37.24.37.45v.48c0 .2-.17.33-.37.29 0 0-1-.22-1.68.24-.76.52-1.58.5-2.32 0a1.95 1.95 0 0 0-2.32 0c-.76.52-1.58.5-2.32 0a1.95 1.95 0 0 0-2.32 0c-.76.52-1.59.5-2.32 0-.65-.44-1.67-.24-1.67-.24-.2.04-.38-.1-.38-.3v-.48c0-.2.17-.4.38-.44 0 0 1.02-.2 1.67.24M17.54 12.16a.56.56 0 0 1-.57-.55c0-.3.25-.56.57-.56h3.15c.31 0 .57.25.57.56 0 .3-.26.55-.57.55h-3.15zM17.46 14.97a.56.56 0 0 1-.57-.55c0-.31.26-.56.57-.56h3.15c.32 0 .57.25.57.56 0 .3-.25.55-.57.55h-3.15zM17.54 17.75a.56.56 0 0 1-.57-.55c0-.31.25-.56.57-.56h3.15c.31 0 .57.25.57.56 0 .3-.26.55-.57.55h-3.15zM26.15 21.14c-.87-.44-2.11-.5-3.1 0-.72.37-1.89.3-1.89.3a.35.35 0 0 0-.37.34v.53c0 .2.17.38.37.4 0 0 1.17.08 1.9-.3.98-.5 2.22-.43 3.09 0l.13.07c.18.07.31-.05.31-.25v-.53c0-.2-.13-.42-.3-.49l-.14-.07zM8.85 21.14c.87-.44 2.1-.5 3.09 0 .72.37 1.9.3 1.9.3.2-.02.37.14.37.34v.53a.4.4 0 0 1-.38.4s-1.17.08-1.9-.3a3.54 3.54 0 0 0-3.08 0l-.14.07c-.17.07-.31-.05-.31-.25v-.53c0-.2.14-.42.31-.49l.14-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 12.26V9.49c0-.6-.12-1.09-.73-1.09s-.73.49-.73 1.09v10.17c-.71.29-1.21.97-1.21 1.77 0 1.06.87 1.91 1.95 1.91s1.96-.85 1.96-1.91c0-.8-.51-1.5-1.24-1.78v-7.39z"
  }))));
});